import { render } from "./SamplingLayout.vue?vue&type=template&id=586a22e2"
import script from "./SamplingLayout.vue?vue&type=script&lang=js"
export * from "./SamplingLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__